// The region every one of our callable functions is deployed in - the only
// copy of the string (see docs/functions-region-migration.md). Lives in its
// own module with no firebase imports so lazily-initialising callers (and
// Jest) can read it without booting the Firebase app.
export const FUNCTIONS_REGION = 'europe-west2';

// The few functions that move file bytes run beside the storage bucket
// instead (downloadFolder streams a whole folder through itself), so both
// legs stay in one region. Callers use their own functions instance for them.
export const BUCKET_FUNCTIONS_REGION = 'us-central1';
